<template>
  <div>
    <div class="mb-8 flex justify-between w-full">
      <h1 class="font-bold text-3xl">
        <inertia-link class="kreditgenie-text-green hover:kreditgenie-text-green-hover"
                      :href="route('clients')"
        >
          Kunde
        </inertia-link>
        <span class="kreditgenie-text-green font-medium">/</span>
        {{ form.first_name }} {{ form.last_name }}
        <img v-if="client.photo" class="block w-8 h-8 rounded-full ml-4" :src="client.photo" />
      </h1>
      <h1 class="font-bold text-3xl align-right">{{ getAssignedTo }}</h1>
    </div>
    <trashed-message v-if="client.deleted_at" class="mb-6" @restore="restore">
      Dieser Kunde wurde gelöscht.
    </trashed-message>

    <div class="bg-white rounded-md shadow overflow-hidden max-w-full">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <div class="w-full">
            <div class="bg-white">
              <nav class="tabs flex flex-col sm:flex-row">
                <button v-for="(tab, index) in tabs"
                        :key="tab"
                        data-target="panel-2"
                        class="tab ext-gray-600 py-4 px-6 block hover:text-blue-500 focus:outline-none"
                        :class="index === selectedTab ? 'active-tab' : ''"
                        @click.prevent="showTab(index)"
                >
                  {{ tab }}
                </button>
              </nav>
            </div>

            <div id="panels">
              <div v-show="selectedTab === 0" class="panel-1 tab-content py-5">
                <text-input v-model="form.first_name" :error="form.errors.first_name"
                            class="pr-6 pb-8 w-full" label="Vorname"
                />
                <text-input v-model="form.last_name" :error="form.errors.last_name"
                            class="pr-6 pb-8 w-full" label="Nachname"
                />
                <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full"
                            label="Email"
                />
                <text-input v-model="form.phone" :error="form.errors.phone" class="pr-6 pb-8 w-full"
                            label="Telefon"
                />
                <text-input v-model="form.address" :error="form.errors.address" class="pr-6 pb-8 w-full"
                            label="Adresse"
                />
                <text-input v-model="form.lives_here_from" :error="form.errors.lives_here_from"
                            class="pr-6 pb-8 w-full"
                            label="Lebt hier ab"
                />
                <text-input v-model="form.zip_code" :error="form.errors.zip_code" class="pr-6 pb-8 w-full"
                            label="Postleitzahl"
                />
                <text-input v-model="form.city" :error="form.errors.city" class="pr-6 pb-8 w-full"
                            label="Stadt"
                />
                <text-input v-model="form.country" :error="form.errors.country" class="pr-6 pb-8 w-full"
                            label="Land"
                />
                <text-input v-model="form.citizenship" :error="form.errors.citizenship"
                            class="pr-6 pb-8 w-full"
                            label="Staatsangehörigkeit"
                />
                <text-input v-model="form.place_of_birth" :error="form.errors.place_of_birth"
                            class="pr-6 pb-8 w-full"
                            label="Geburtsort"
                />
                <text-input v-model="form.gender" :error="form.errors.gender" class="pr-6 pb-8 w-full"
                            label="Anrede"
                />
                <text-input v-model="form.date_of_birth" :error="form.errors.date_of_birth"
                            class="pr-6 pb-8 w-full"
                            label="Geburtsdatum"
                />
                <text-input v-model="form.family_status" :error="form.errors.family_status"
                            class="pr-6 pb-8 w-full"
                            label="Familienstand"
                />
                <text-input v-model="form.work_permit_type" :error="form.errors.work_permit_type"
                            class="pr-6 pb-8 w-full"
                            label="Art der Aufenthaltserlaubnis"
                />
                <text-input v-model="form.number_of_kids_with_benefit"
                            :error="form.errors.number_of_kids_with_benefit" class="pr-6 pb-8 w-full"
                            label="Anzahl der Kinder mit Leistungen"
                />
                <select-input
                  v-model="form.user_id" label="Adviser"
                  :error="form.errors.user_id"
                  class="pr-6 pb-8 w-full"
                >
                  <option v-for="user in users" :key="user.id" :value="user.id">
                    {{ user.first_name + ' ' + user.last_name }} {{ user.user_function ? '(' + user.user_function + ')' : '' }}
                  </option>
                </select-input>
              </div>
              <div v-show="selectedTab === 1" class="panel-2 tab-content py-5">
                <text-input v-model="form.occupation" :error="form.errors.occupation"
                            class="pr-6 pb-8 w-full"
                            label="Beruf"
                />
                <text-input v-model="form.company" :error="form.errors.company" class="pr-6 pb-8 w-full"
                            label="Firma"
                />
                <text-input v-model="form.started_working_at" :error="form.errors.started_working_at"
                            class="pr-6 pb-8 w-full"
                            label="Eintrittsdatum"
                />
                <text-input v-model="form.employment_type" :error="form.errors.employment_type"
                            class="pr-6 pb-8 w-full"
                            label="Beschäftigungsverhältnis"
                />
                <select-input v-model="form.is_probation_period"
                              :error="form.errors.status"
                              class="pr-6 pb-8 w-full" label="Probezeit"
                >
                  <option :key="1" :value="1">
                    Ja
                  </option>
                  <option :key="0" :value="0">
                    Nein
                  </option>
                </select-input>
                <text-input v-model="form.probation_period_until" :error="form.errors.probation_period_until"
                            class="pr-6 pb-8 w-full"
                            label="Probezeit bis"
                />
                <text-input v-model="form.number_of_salaries" :error="form.errors.number_of_salaries"
                            class="pr-6 pb-8 w-full"
                            label="Anzahl der Gehälter"
                />
                <text-input v-model="form.average_monthly_income" :error="form.errors.average_monthly_income"
                            class="pr-6 pb-8 w-full"
                            label="Durchschnittliches monatliches Einkommen"
                />
                <text-input v-model="form.other_income" :error="form.errors.other_income"
                            class="pr-6 pb-8 w-full"
                            label="Anderes Einkommen"
                />
                <text-input v-model="form.other_income_source" :error="form.errors.other_income_source"
                            class="pr-6 pb-8 w-full"
                            label="Andere Einnahmequelle"
                />
              </div>
              <div v-show="selectedTab === 2" class="panel-3 tab-content py-5">
                <text-input v-model="form.number_of_credits" :error="form.errors.number_of_credits"
                            class="pr-6 pb-8 w-full"
                            label="Anzahl der Kredite"
                />
                <select-input v-model="form.has_rent"
                              :error="form.errors.status"
                              class="pr-6 pb-8 w-full" label="Hat Miete?"
                >
                  <option :key="1" :value="1">
                    Ja
                  </option>
                  <option :key="0" :value="0">
                    Nein
                  </option>
                </select-input>
                <text-input v-model="form.rent_amount" :error="form.errors.rent_amount"
                            class="pr-6 pb-8 w-full"
                            label="Mietbetrag"
                />
                <select-input v-model="form.has_furniture_expenses"
                              :error="form.errors.status"
                              class="pr-6 pb-8 w-full" label="Eigentum?"
                >
                  <option :key="1" :value="1">
                    Ja
                  </option>
                  <option :key="0" :value="0">
                    Nein
                  </option>
                </select-input>
                <text-input v-model="form.furniture_expenses_rate" :error="form.errors.furniture_expenses_rate"
                            class="pr-6 pb-8 w-full"
                            label="Finanzierungrate"
                />
                <select-input v-model="form.has_leasing"
                              :error="form.errors.status"
                              class="pr-6 pb-8 w-full" label="Hat Leasing?"
                >
                  <option :key="1" :value="1">
                    Ja
                  </option>
                  <option :key="0" :value="0">
                    Nein
                  </option>
                </select-input>
                <text-input v-model="form.leasing_rate" :error="form.errors.leasing_rate"
                            class="pr-6 pb-8 w-full"
                            label="Leasingrate"
                />
                <text-input v-model="form.iban" :error="form.errors.iban" class="pr-6 pb-8 w-full"
                            label="IBAN"
                />
              </div>
              <div v-show="selectedTab === 3" class="panel-3 tab-content py-5">
                <select-input
                  v-model="form.type"
                  :error="form.errors.type"
                  class="pr-6 pb-8 w-full"
                  label="Kreditart"
                >
                  <option value="private_credit">Privatkredit</option>
                  <option value="property_credit">Immobilienkredit</option>
                </select-input>
                <text-input v-model="form.credit_purpose" :error="form.errors.credit_purpose"
                            class="pr-6 pb-8 w-full"
                            label="Kreditzweck"
                />
                <text-input v-model="form.wanted_credit_amount" :error="form.errors.wanted_credit_amount"
                            class="pr-6 pb-8 w-full"
                            label="Gewünschter Kreditbetrag"
                />
                <text-input v-model="form.period" :error="form.errors.period" class="pr-6 pb-8 w-full"
                            label="Zeitraum (in Monaten)"
                />
                <text-input v-model="form.credit_securing" :error="form.errors.credit_securing"
                            class="pr-6 pb-8 w-full"
                            label="Kreditsicherung"
                />
              </div>
              <div v-show="selectedTab === 4" class="panel-3 tab-content py-5">
                <table class="w-full border-collapse mb-5 mr-5">
                  <tr>
                    <td class="px-2
              bg-blueGray-50
              text-blueGray-500
              border border-solid
              border-blueGray-100
              py-3
              border-l-0
              border-r-0
              whitespace-nowrap
              font-semibold"
                    >
                      #
                    </td>
                    <td class="px-2
              bg-blueGray-50
              text-blueGray-500
              border border-solid
              border-blueGray-100
              py-3
              border-l-0
              border-r-0
              whitespace-nowrap
              font-semibold"
                    >
                      Schuldenbetrag
                    </td>
                    <td class="px-2
              bg-blueGray-50
              text-blueGray-500
              border border-solid
              border-blueGray-100
              py-3
              border-l-0
              border-r-0
              whitespace-nowrap
              font-semibold"
                    >
                      Monatliche Rate
                    </td>
                    <td class="px-2
              bg-blueGray-50
              text-blueGray-500
              border border-solid
              border-blueGray-100
              py-3
              border-l-0
              border-r-0
              whitespace-nowrap
              font-semibold"
                    >
                      Endtermin
                    </td>
                    <td class="px-2
              bg-blueGray-50
              text-blueGray-500
              border border-solid
              border-blueGray-100
              py-3
              border-l-0
              border-r-0
              whitespace-nowrap
              font-semibold"
                    >
                      Bank Name
                    </td>
                    <td class="px-2
              bg-blueGray-50
              text-blueGray-500
              border border-solid
              border-blueGray-100
              py-3
              border-l-0
              border-r-0
              whitespace-nowrap
              font-semibold"
                    >
                      IBAN
                    </td>
                    <td class="px-2
              bg-blueGray-50
              text-blueGray-500
              border border-solid
              border-blueGray-100
              py-3
              border-l-0
              border-r-0
              whitespace-nowrap
              font-semibold"
                    >
                      Soll abgelöst werden?
                    </td>
                  </tr>
                  <tr v-for="(client_credit, index) in client.client_credits" :key="client_credit.id">
                    <td class="px-2
              bg-blueGray-50
              text-blueGray-500
              border
              border-solid
              border-blueGray-100
               py-3
                border-l-0
                border-r-0
                whitespace-nowrap
                 font-semibold"
                    >
                      {{ index + 1 }}
                    </td>
                    <td class="px-2
              bg-blueGray-50
              text-blueGray-500
              border
              border-solid
              border-blueGray-100
               py-3
                border-l-0
                border-r-0
                whitespace-nowrap
                 font-semibold"
                    >
                      {{ client_credit.debt_amount }}
                    </td>

                    <td class="px-2
              bg-blueGray-50
              text-blueGray-500
              border
              border-solid
              border-blueGray-100
               py-3
                border-l-0
                border-r-0
                whitespace-nowrap
                 font-semibold"
                    >
                      {{ client_credit.monthly_amount_rate }}
                    </td>

                    <td class="px-2
              bg-blueGray-50
              text-blueGray-500
              border
              border-solid
              border-blueGray-100
               py-3
                border-l-0
                border-r-0
                whitespace-nowrap
                 font-semibold"
                    >
                      {{ client_credit.end_date }}
                    </td>

                    <td class="px-2
              bg-blueGray-50
              text-blueGray-500
              border
              border-solid
              border-blueGray-100
               py-3
                border-l-0
                border-r-0
                whitespace-nowrap
                 font-semibold"
                    >
                      {{ client_credit.bank_name }}
                    </td>

                    <td class="px-2
              bg-blueGray-50
              text-blueGray-500
              border
              border-solid
              border-blueGray-100
               py-3
                border-l-0
                border-r-0
                whitespace-nowrap
                 font-semibold"
                    >
                      {{ client_credit.iban_number }}
                    </td>

                    <td class="px-2
              bg-blueGray-50
              text-blueGray-500
              border
              border-solid
              border-blueGray-100
               py-3
                border-l-0
                border-r-0
                whitespace-nowrap
                 font-semibold"
                    >
                      {{ client_credit.should_redeem ? 'Ja' : 'Nein' }}
                    </td>
                  </tr>
                </table>
              </div>
              <div v-show="selectedTab === 5" class="panel-3 tab-content py-5">
                <file-input v-model="form.photo" :error="form.errors.photo" class="pr-6 pb-8 w-full "
                            type="file" accept="image/*, application/pdf" label="Datei"
                />

                <div v-for="(file, index) in client.client_files" :key="file.id" class="w-full mb-6 lg:w-1/6">
                  <template v-if="form.deleted_files.indexOf(file.id) === -1">
                    <div class="cursor-pointer" title="Remove file" @click.prevent="removeImage(file.id)">
                      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img"
                           class="iconify iconify--clarity float-left mr-2" width="20" height="20"
                           preserveAspectRatio="xMidYMid meet" viewBox="0 0 36 36"
                      >
                        <path class="clr-i-solid clr-i-solid-path-1"
                              d="M18 2a16 16 0 1 0 16 16A16 16 0 0 0 18 2zm8 22.1a1.4 1.4 0 0 1-2 2l-6-6l-6 6.02a1.4 1.4 0 1 1-2-2l6-6.04l-6.17-6.22a1.4 1.4 0 1 1 2-2L18 16.1l6.17-6.17a1.4 1.4 0 1 1 2 2L20 18.08z"
                              fill="currentColor"
                        />
                      </svg>
                    </div>
                    <a class="float-left" :href="file.path" target="_blank">Datei #{{ index + 1 }}</a>
                  </template>
                </div>
              </div>
              <div v-show="selectedTab === 6" class="panel-3 tab-content py-5">
                <div class="w-full mb-6">
                  <h1 class="w-full">Notizen</h1>
                  <div v-for="note in client.client_notes" :key="note.id"
                       class="my-6 p-2 mr-5 border border-gray-200 border-solid"
                  >
                    <inertia-link class="px-6 py-4 flex items-center" :href="route('notes.edit', note.id)"
                                  tabindex="-1"
                    >
                      <div class="w-full">Datum: {{ note.created_at }}</div>
                    </inertia-link>
                    <inertia-link class="px-6 py-4 flex items-center" :href="route('notes.edit', note.id)"
                                  tabindex="-1"
                    >
                      <div class="w-full">Notiz: {{ note.content }}</div>
                    </inertia-link>
                    <inertia-link class="px-6 py-4 flex items-center" :href="route('notes.edit', note.id)"
                                  tabindex="-1"
                    >
                      <div class="w-full">Benutzer: {{ getClientNoteCreator(note.user_id) }}</div>
                    </inertia-link>
                  </div>
                </div>
                <inertia-link class="btn-green mb-6" :href="route('notes.create')" @click="transferClientId">
                  <span>+ Notiz</span>
                </inertia-link>
              </div>
            </div>
            <div v-show="selectedTab === 7" class="panel-3 tab-content py-5">
              <textarea-input v-model="form.note" :error="form.errors.note" class="pr-6 pb-8 w-full"
                              label="Kundennotiz"
              />
              <text-input v-model="form.agreement_accepted_at" :error="form.errors.agreement_accepted_at"
                          class="pr-6 pb-8 w-full"
                          label="Vereinbarung angenommen um"
              />
              <!--              <div class="mt-2 mb-6 w-full font-bold">-->
              <!--                Formular über URL geöffnet:-->
              <!--                {{ client.referential_url ? client.referential_url : 'Direkte Einreichung' }}-->
              <!--              </div>-->
              <h2 class="font-bold">Daten der 2. Person:</h2>
              <div v-if="checkSecondPersonData(client.second_person_data)" class="mt-2 mb-6 w-full">
                <div v-if="client.second_person_data.first_name">Vorname: {{ client.second_person_data.first_name }}</div>
                <div v-if="client.second_person_data.last_name">Nachname: {{ client.second_person_data.last_name }}</div>
                <div v-if="client.second_person_data.gender">Anrede: {{ client.second_person_data.gender }}</div>
                <div v-if="client.second_person_data.address">Adresse: {{ client.second_person_data.address }}</div>
                <div v-if="client.second_person_data.zip_code">Postleitzahl: {{ client.second_person_data.zip_code }}</div>
                <div v-if="client.second_person_data.city">Stadt: {{ client.second_person_data.city }}</div>
                <div v-if="client.second_person_data.country">Land: {{ client.second_person_data.country }}</div>
                <div v-if="client.second_person_data.citizenship">Staatsangehörigkeit: {{ client.second_person_data.citizenship }}</div>
                <div v-if="client.second_person_data.email">Email: {{ client.second_person_data.email }}</div>
                <div v-if="client.second_person_data.phone">Telefon: {{ client.second_person_data.phone }}</div>
                <div v-if="client.second_person_data.date_of_birth">Geburtsdatum: {{ client.second_person_data.date_of_birth }}</div>
                <div v-if="client.second_person_data.iban">IBAN: {{ client.second_person_data.iban }}</div>
              </div>
              <div v-else>
                Keine Daten.
              </div>
              <select-input
                v-model="form.status"
                :error="form.errors.status"
                class="pr-6 pt-4 pb-4 w-1/2"
                label="Status"
              >
                <option v-for="(status) in form.statuses" :key="status.key" :value="status.key">
                  {{ statuses[status.key] }}
                </option>
              </select-input>
              <div class="flex">
                <span
                  class="px-6 py-4 flex items-center text-black text-sm"
                  :class="`${getLastStatus(client.client_status).color}`"
                  style="width: auto"
                  tabindex="-1"
                >
                  {{ getLastStatus(client.client_status).name }}
                </span>
                <div
                  class="ml-2 text-gray-400 hover:text-gray-600 focus:outline-none text-right btn-green-small py-1 px-1 cursor-pointer"
                  style="width: auto; border-radius: 100%"
                  @click="showStatusModal = true"
                >
                  <icon name="edit" style="width: 20px; height: 20px" class="mt-2" />
                </div>
              </div>
              <select-input
                v-model="form.source"
                :error="form.errors.source"
                class="pr-6 pt-4 pb-4 w-1/2"
                label="Source"
              >
                <option v-for="(source) in form.sources" :key="source.key" :value="source.key">
                  {{ sources[source.key] }}
                </option>
              </select-input>

              <select-input
                v-model="form.referral_code"
                :error="form.errors.referral_code"
                class="pr-6 pt-4 pb-4 w-1/2"
                label="Influencer"
              >
                <option :value="null">Kein Influencer</option>
                <option
                  v-for="influencer in influencers"
                  :key="influencer.id"
                  :value="influencer.influencer_code"
                >
                  {{ influencer.first_name }} {{ influencer.last_name }}
                </option>
              </select-input>

              <div v-if="form.referral_code" class="pr-6 pt-4 pb-4 w-full">
                <inertia-link
                  class="btn-green ml-auto"
                  :href="route('influencers.edit', form.referral_code)"
                >
                  Öffne Influencer
                </inertia-link>
              </div>
            </div>
            <div v-show="selectedTab === 8" class="panel-3 tab-content py-5">
              <h3 class="font-semibold pb-4">Finanzierungswunsch</h3>
              <select-input
                v-model="form.property_type"
                :error="form.errors.property_type"
                class="pr-6 pb-8 w-full"
                label="Immobilienart"
              >
                <option value="ETW">Etagenwohnung</option>
                <option value="EFH">Einfamilienhaus</option>
                <option value="ZFH">Zweifamilienhaus</option>
                <option value="MFH">Mehrfamilienhaus</option>
                <option value="Bauvorhaben">Bauvorhaben</option>
              </select-input>
              <select-input
                v-model="form.financing_wish"
                :error="form.errors.financing_wish"
                class="pr-6 pb-8 w-full"
                label="Finanzierungswunsch"
              >
                <option value="Kaufvorhaben">Kauffinanzierung</option>
                <option value="Anschlussfinanzierung">Anschlussfinanzierung</option>
                <option value="Modernisierung">Modernisierung</option>
                <option value="Kapitalbeschaffung">Kapitalbeschaffung</option>
              </select-input>
              <text-input
                v-model="form.purchase_price"
                :error="form.errors.purchase_price"
                class="pr-6 pb-8 w-full"
                label="Kaufpreis bzw. Kosten (ohne Nebenkosten)"
              />
              <text-input
                v-model="form.equity"
                :error="form.errors.equity"
                class="pr-6 pb-8 w-full"
                label="Eigenkapital, falls vorhanden"
              />
              <select-input
                v-model="form.subsidies"
                :error="form.errors.subsidies"
                class="pr-6 pb-8 w-full"
                label="Fördermittel?"
              >
                <option value="Bau oder Modernisierung">KfW 261</option>
                <option value="Eigennutzer">KfW 124</option>
                <option value="WfA Mittel">NRW.Bank | WfA</option>
                <option value="Weiß ich nicht">Weiß ich nicht</option>
              </select-input>

              <h3 class="font-semibold pb-4 pt-4">Kaufimmobilie</h3>
              <text-input
                v-model="form.property_zip_code"
                :error="form.errors.property_zip_code"
                class="pr-6 pb-8 w-full"
                label="Adresse (PLZ) der Immobilie"
              />
              <text-input
                v-model="form.living_area"
                :error="form.errors.living_area"
                class="pr-6 pb-8 w-full"
                label="Wohnfläche (m²)"
              />

              <h3 class="font-semibold pb-4 pt-4">Person 1</h3>
              <div class="flex">
                <text-input
                  v-model="form.first_name"
                  :error="form.errors.first_name"
                  class="pr-6 pb-8 w-1/2"
                  label="Vorname"
                />
                <text-input
                  v-model="form.last_name"
                  :error="form.errors.last_name"
                  class="pr-6 pb-8 w-1/2"
                  label="Nachname"
                />
              </div>
              <text-input
                v-model="form.phone"
                :error="form.errors.phone"
                class="pr-6 pb-8 w-full"
                label="Telefon"
              />
              <text-input
                v-model="form.address"
                :error="form.errors.address"
                class="pr-6 pb-8 w-full"
                label="Adresse (Straße, Nr.)"
              />
              <text-input
                v-model="form.date_of_birth"
                :error="form.errors.date_of_birth"
                class="pr-6 pb-8 w-full"
                label="Geburtstag"
              />
              <text-input
                v-model="form.family_status"
                :error="form.errors.family_status"
                class="pr-6 pb-8 w-full"
                label="Familienstand"
              />
              <text-input
                v-model="form.email"
                :error="form.errors.email"
                class="pr-6 pb-8 w-full"
                label="E-Mail-Adresse"
              />
              <text-input
                v-model="form.zip_code"
                :error="form.errors.zip_code"
                class="pr-6 pb-8 w-full"
                label="Adresse (PLZ)"
              />
              <text-input
                v-model="form.number_of_kids_with_benefit"
                :error="form.errors.number_of_kids_with_benefit"
                class="pr-6 pb-8 w-full"
                label="Kinder im Haushalt"
              />
              <text-input
                v-model="form.occupation"
                :error="form.errors.occupation"
                class="pr-6 pb-8 w-full"
                label="Beruf"
              />
              <text-input
                v-model="form.average_monthly_income"
                :error="form.errors.average_monthly_income"
                class="pr-6 pb-8 w-full"
                label="mtl. Nettogehalt"
              />
              <text-input
                v-model="form.started_working_at"
                :error="form.errors.started_working_at"
                class="pr-6 pb-8 w-full"
                label="Beschäftigungsbeginn"
              />
              <text-input
                v-model="form.rent_amount"
                :error="form.errors.rent_amount"
                class="pr-6 pb-8 w-full"
                label="ggf. Miete"
              />
              <text-input
                v-model="form.current_credit_rates"
                :error="form.errors.current_credit_rates"
                class="pr-6 pb-8 w-full"
                label="lfd. Kreditraten (mtl.)"
              />

              <h3 class="font-semibold pb-4 pt-4">2. Person</h3>
              <div class="flex">
                <text-input
                  v-model="form.second_person_data.first_name"
                  class="pr-6 pb-8 w-1/2"
                  label="Vorname"
                />
                <text-input
                  v-model="form.second_person_data.last_name"
                  class="pr-6 pb-8 w-1/2"
                  label="Nachname"
                />
              </div>
              <text-input
                v-model="form.second_person_data.family_status"
                class="pr-6 pb-8 w-full"
                label="Familienstand"
              />
              <text-input
                v-model="form.second_person_data.date_of_birth"
                class="pr-6 pb-8 w-full"
                label="Geburtsdatum"
              />
              <text-input
                v-model="form.second_person_data.income"
                class="pr-6 pb-8 w-full"
                label="Einkommen (mtl.)"
              />
              <text-input
                v-model="form.second_person_data.credit_rates"
                class="pr-6 pb-8 w-full"
                label="lfd. Kreditraten (mtl.)"
              />

              <h3 class="font-semibold pb-4 pt-4">Zusatzinformationen</h3>
              <text-input
                v-model="form.additional_info"
                :error="form.errors.additional_info"
                class="pr-6 pb-8 w-full"
                label="Zusatzinformationen"
              />
            </div>
          </div>
        </div>

        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!client.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button"
                  @click="destroy"
          >
            Löschen
          </button>
          <loading-button :loading="form.processing" class="btn-green ml-auto" type="submit">
            Aktualisieren
          </loading-button>
        </div>
      </form>
    </div>
    <modal
      :show="showStatusModal"
      @close="showStatusModal = false"
    >
      <div>
        <template>
          <h1 class="text-lg font-bold uppercase border-b">Statusverlauf</h1>
        </template>
        <template>
          <div v-if="selectedClient">
            <p class="py-2"><strong>Name:</strong> {{ selectedClient.name || `${selectedClient.first_name} ${selectedClient.last_name}` }}</p>
            <p class="py-2"><strong>Email:</strong> {{ selectedClient.email }}</p>
            <p class="py-2"><strong>Telefon:</strong> {{ selectedClient.phone }}</p>
            <p class="py-2"><strong>Gewünschter Kreditbetrag:</strong> {{ selectedClient.wanted_credit_amount || selectedClient.credit_amount }}</p>
            <p class="py-2"><strong>Statusverlauf:</strong></p>
            <table class="w-full">
              <thead class="bg-gray-50">
                <tr>
                  <td class="py-4 px-4 border-r border-white">Status</td>
                  <td class="py-4 px-4 border-r border-white">Zustand</td>
                  <td class="py-4 px-4 border-r border-white">Zeitpunkt</td>
                  <td class="py-4 px-4">Benutzer</td>
                </tr>
              </thead>
              <tr
                v-for="(status) in statusFlags()"
                :key="status.key"
              >
                <td
                  class="border-b py-2 px-4"
                  :class="{
                    'bg-yellow-200': ((selectedClient.client_status || []).find(item => item.name === status.key) || {}).state === 'in_progress',
                    'bg-green-200': ((selectedClient.client_status || []).find(item => item.name === status.key) || {}).state === 'completed',
                  }"
                >
                  {{ status.value }}
                </td>
                <td>
                  <select-input
                    v-model="((selectedClient.client_status || []).find(item => item.name === status.key) || {}).state"
                    class="px-2"
                    @input="statusFlagChange(selectedClient.id, status.key, $event)"
                  >
                    <option v-for="item in [
                              {key: '', name: ''},
                              {key: 'in_progress', name: 'In Bearbeitung'},
                              {key: 'completed', name: 'Abgeschlossen'},
                            ]"
                            :key="item.key"
                            :value="item.key"
                    >
                      {{ item.name }}
                    </option>
                  </select-input>
                </td>
                <td>
                  {{ getChangeTime(selectedClient, status) }}
                </td>
                <td>
                  {{ getChangeUser(selectedClient, status, users) }}
                </td>
              </tr>
              <tr><td colspan="4">&nbsp;</td></tr>
              <tr class="py-5">
                <td
                  class="border-b py-2 px-4"
                  :class="`status-${selectedClient.status}`"
                >
                  <strong>General Status</strong>
                </td>
                <td style="width: 156px">
                  <select-input
                    v-model="selectedClient.status"
                    class="w-full px-2"
                    @input="statusGeneralChange(selectedClient.id, $event)"
                  >
                    <option
                      v-for="(status) in convertStatusesToArray(statuses)"
                      :key="status.key"
                      :value="status.key"
                    >
                      {{ statuses[status.key] }}
                    </option>
                  </select-input>
                </td>
                <td>
                  {{ selectedClient.status_changed_at ? selectedClient.status_changed_at : '' }}
                </td>
                <td>
                  {{ selectedClient.user_id ? getUserData(selectedClient.user_id) : '' }}
                </td>
              </tr>
            </table>
            <div class="w-full my-b mt-8">
              <h1 class="text-lg font-bold uppercase border-b">Notizen</h1>
            </div>
            <div class="flex my-4">
              <div class="w-full">
                <textarea-input
                  v-model="noteText"
                  class="w-full"
                  label="Notiz"
                />
                <div class="w-full text-center">
                  <button
                    class="btn-green mt-2"
                    @click="addNote(selectedClient.id, noteText)"
                  >
                    <span>Notiz speichern</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="w-full mt-2">
              <div v-for="note in selectedClientNotes" :key="note.id" class="w-full mt-1">
                <div class="bg-gray-100 p-2 rounded-md mb-1">
                  <!-- delete-note -->
                  <div
                    class="float-right text-red-500 cursor-pointer border-red-500 border rounded-full w-6 h-6 flex items-center justify-center"
                    @click="deleteNote(note.id, selectedClient.id)"
                  >
                    <icon name="trash" class="w-3 h-3 fill-red-500" />
                  </div>
                  <p class="text-sm" v-html="note.content" />
                  <p class="text-xs text-gray-500 mt-1">
                    <strong>{{ getUserData(note.user_id) }}</strong> - {{ note.created_at }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </modal>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Modal from '@/Shared/Modal'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import SelectInput from '../../Shared/SelectInput'
import statuses from './statuses'
import sources from './sources'
import TextareaInput from '../../Shared/TextareaInput'
import {Inertia} from '@inertiajs/inertia'
import {convertStatusesToArray, getLastStatus} from './statesHelper'
import {statusFlags} from './statusFlags'
import {getChangeTime, getChangeUser} from '../../utils'

export default {
  metaInfo() {
    return {
      title: `${this.form.first_name} ${this.form.last_name}`,
    }
  },
  components: {
    TextareaInput,
    SelectInput,
    FileInput,
    LoadingButton,
    TextInput,
    TrashedMessage,
    Icon,
    Modal,
  },
  layout: Layout,
  props: {
    client: Object,
    users: Array,
    influencers: Array,
  },
  remember: 'form',
  data() {
    console.log(this.client)
    const tabs = [
      'Basisinformation',
      'Beruf',
      'Finanzdaten',
      'Kredit',
      'Bestehende Kredite',
      'Datei',
      'Notizen',
      'Andere',
      'Immobilienkredit',
    ]
    const selectedTab = 0

    return {
      noteText: '',
      selectedClientNotes: this.client.client_notes || [],
      showStatusModal: false,
      selectedClient: {...this.client},
      form: this.$inertia.form({
        _method: 'post',
        first_name: this.client.first_name,
        last_name: this.client.last_name,
        email: this.client.email,
        phone: this.client.phone,
        address: this.client.address,
        lives_here_from: this.client.lives_here_from,
        zip_code: this.client.zip_code,
        city: this.client.city,
        country: this.client.country,
        citizenship: this.client.citizenship,
        place_of_birth: this.client.place_of_birth,
        gender: this.client.gender,
        date_of_birth: this.client.date_of_birth,
        family_status: this.client.family_status,
        work_permit_type: this.client.work_permit_type,
        number_of_kids_with_benefit: this.client.number_of_kids_with_benefit,
        occupation: this.client.occupation,
        company: this.client.company,
        started_working_at: this.client.started_working_at,
        employment_type: this.client.employment_type,
        is_probation_period: this.client.is_probation_period,
        probation_period_until: this.client.probation_period_until,
        number_of_salaries: this.client.number_of_salaries,
        average_monthly_income: this.client.average_monthly_income,
        other_income: this.client.other_income,
        other_income_source: this.client.other_income_source,
        number_of_credits: this.client.number_of_credits,
        has_rent: this.client.has_rent,
        rent_amount: this.client.rent_amount,
        has_furniture_expenses: this.client.has_furniture_expenses,
        furniture_expenses_rate: this.client.furniture_expenses_rate,
        has_leasing: this.client.has_leasing,
        leasing_rate: this.client.leasing_rate,
        has_maintenance: this.client.has_maintenance,
        iban: this.client.iban,
        note: this.client.note,
        agreement_accepted_at: this.client.agreement_accepted_at,
        credit_purpose: this.client.credit_purpose,
        wanted_credit_amount: this.client.wanted_credit_amount,
        period: this.client.period,
        credit_securing: this.client.credit_securing,
        status: this.client.status,
        photo: null,
        deleted_at: this.client.deleted_at,
        referential_url: this.client.referential_url,
        statuses: this.client.statuses,
        deleted_files: [],
        notes: this.client.client_notes,
        source: this.client.source,
        sources: this.client.sources,
        referral_code: this.client.referral_code,
        user_id: this.client.user_id,
        second_person_data: this.client.second_person_data || {
          first_name: '', last_name: '', email: '', phone: '', address: '',
          zip_code: '', city: '', country: '', citizenship: '', date_of_birth: '',
          iban: '', family_status: '', income: '', credit_rates: '',
        },
        type: this.client.type || null,
        property_type: this.client.property_type || null,
        financing_wish: this.client.financing_wish || null,
        purchase_price: this.client.purchase_price || null,
        equity: this.client.equity || null,
        subsidies: this.client.subsidies || null,
        property_zip_code: this.client.property_zip_code || null,
        living_area: this.client.living_area || null,
        additional_info: this.client.additional_info || null,
        current_credit_rates: this.client.current_credit_rates || null,
      }),
      statuses,
      sources,
      tabs,
      selectedTab,
    }
  },
  computed: {
    getAssignedTo() {
      const user = this.users.find(user => user.id === this.client.user_id)
      return user ? user.first_name + ' ' + user.last_name : 'Nicht zugeordnet'
    },
  },
  methods: {
    deleteNote(id, clientId) {
      if (!confirm('Sind Sie sicher, dass Sie diese Notiz löschen möchten?')) {
        return
      }
      fetch(`/api/client-notes/${id}/${clientId}`, {
        method: 'DELETE',
      })
        .then(res => res.json())
        .then(data => {
          Inertia.reload()
          this.selectedClientNotes = data
        })
        .catch(error => {
          console.error('Error:', error)
        })
    },
    addNote(selectedClientId, noteText) {
      if (!noteText) {
        alert('Bitte geben Sie eine Notiz ein.')
        return
      }
      fetch('/api/client-notes', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          clientId: selectedClientId,
          content: noteText,
          userId: this.$page.props.auth.user.id,
        }),
      })
        .then(res => res.json())
        .then(data => {
          Inertia.reload()
          this.selectedClientNotes = data
          this.noteText = ''
        })
        .catch(error => {
          console.error('Error:', error)
        })
    },
    async getClientNotes(clientId) {
      await fetch(`/api/client-notes/${clientId}`)
        .then(res => res.json())
        .then(data => {
          this.selectedClientNotes = data
          return data
        })
        .catch(error => {
          console.error('Error:', error)
          return []
        })
    },
    getChangeTime,
    getChangeUser,
    convertStatusesToArray,
    statusFlags() {
      return statusFlags
    },
    getLastStatus,
    getUserData(id) {
      const user = this.users.find((user) => user.id === id)
      if(user) {
        return user.first_name + ' ' + user.last_name
      }
      return 'Nicht zugeordnet'
    },
    statusGeneralChange(clientId, status) {
      fetch('/api/client-status/general', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ status, clientId, userId: this.$page.props.auth.user.id }),
      })
        .then(res => res.json())
        .then(data => {
          Inertia.reload()
          this.selectedClient = {...data}
        })
        .catch(error => {
          console.error('Error:', error)
        })
    },
    statusFlagChange(clientId, name, state) {
      fetch('/api/client-status', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name, state, clientId, userId: this.$page.props.auth.user.id }),
      })
        .then(res => res.json())
        .then(data => {
          Inertia.reload()
          this.selectedClient = {...data}
        })
        .catch(error => {
          console.error('Error:', error)
        })
    },
    checkSecondPersonData(secondPerson) {
      return !(!secondPerson.first_name && !secondPerson.last_name)
    },
    transferClientId() {
      localStorage.setItem('client_id', this.client.id)
    },
    removeImage(id) {
      if (this.form.deleted_files.indexOf(id) === -1) {
        this.form.deleted_files.push(id)
      }
    },
    update() {
      this.form.post(this.route('clients.update', this.client.id).url(), {
        onSuccess: () => {
          this.form.reset('photo')
          this.form.deleted_files = []
        },
      })
    },
    destroy() {
      if (confirm('Möchten Sie diesen Kunden wirklich löschen?')) {
        this.$inertia.delete(this.route('clients.destroy', this.client.id))
      }
    },
    restore() {
      if (confirm('Möchten Sie diesen Kunden wirklich wiederherstellen??')) {
        this.$inertia.put(this.route('clients.restore', this.client.id))
      }
    },
    getClientNoteCreator(id) {
      const user = this.users.find(user => user.id === id)
      return user ? user.first_name + ' ' + user.last_name : ''
    },
    showTab(index){
      this.selectedTab = index
    },
  },
}
</script>
<style scoped>
    .active-tab {
        border-bottom: 2px solid #56baa2;
    }
</style>
